var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:26px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "help-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 150,
    cy: 150,
    r: 132
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164.59619,185.16279H136.28861V152.21162c0-32.28861,31.62454-31.1827,31.62454-46.88461,0-11.72125-8.84574-15.4808-17.47075-15.4808-12.38494,0-19.46146,7.298-18.35593,20.12478H104c.22111-30.519,19.46146-45.115,46.4424-45.115C173.2212,64.856,196,77.46165,196,105.327c0,26.09614-31.40381,31.62492-31.40381,46.88461Zm-13.93307,11.279a19.35141,19.35141,0,1,1-19.24,19.46184A19.34983,19.34983,0,0,1,150.66312,196.44183Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help-icon.35d1075defe3502e5a5cae6358f4ba0b.svg";
export { ForwardRef as ReactComponent };